import { initTitleLineRevealOnView } from '../parts/highlight-sweep';
import { initBgVideoReveal } from '../parts/helpers';
initTitleLineRevealOnView('.block-hero__title', '.js--gradient-highlight-hero');
initBgVideoReveal('.block-hero__bg-video');
